import React from 'react';
import './Footer.scss';

const Footer: React.FC = () => {
  const footerId = 'footer';
  const currentYear = new Date().getFullYear();
  
  return (
    <footer 
      id={footerId} 
      data-testid={footerId} 
      className="addapt-footer"
      role="contentinfo"
    >
      <ul className="addapt-footer__list">
        <li className="addapt-footer__item">
          © {currentYear}, Amazon Web Services, Inc. or its affiliates
        </li>
      </ul>
    </footer>
  );
};

export default Footer;
